import { GetDeliveryZonesRequest } from '../../delivery-zones/hooks/admin-get-delivery-zones.hook';

export const ALL_DELIVERY_CITY_ZONES = 'all';

export const LIVE_DELIVERY_ZONES_REQUEST: GetDeliveryZonesRequest = {
  page: 1,
  limit: 100,
  sortBy: 'name',
  sortDirection: 'asc',
  filters: {},
};
